module.exports = __webpack_public_path__ + "media/images/icons/material/person-14c2bba6fb884aa77ccd8a8629157d92.svg";